(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barkbox-faq-section"] && !Shopify.designMode) return;
  try {
    
  /**
   * BarkBox FAQ Toggle Functionality
   */
  function toggleFAQ(button) {
    if (!button) return;
    
    const answer = button.nextElementSibling;
    const toggle = button.querySelector('.barkbox-faq__toggle');
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    
    // Close all other FAQ items
    document.querySelectorAll('.barkbox-faq__question').forEach(function(otherButton) {
      if (otherButton !== button) {
        otherButton.setAttribute('aria-expanded', 'false');
        const otherAnswer = otherButton.nextElementSibling;
        const otherToggle = otherButton.querySelector('.barkbox-faq__toggle');
        
        if (otherAnswer) otherAnswer.classList.remove('active');
        if (otherToggle) otherToggle.classList.remove('active');
      }
    });
    
    // Toggle current FAQ item
    if (isExpanded) {
      button.setAttribute('aria-expanded', 'false');
      if (answer) answer.classList.remove('active');
      if (toggle) toggle.classList.remove('active');
    } else {
      button.setAttribute('aria-expanded', 'true');
      if (answer) answer.classList.add('active');
      if (toggle) toggle.classList.add('active');
    }
  }

  // Initialize FAQ functionality when DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Add click event listeners to FAQ questions
    document.querySelectorAll('.barkbox-faq__question').forEach(function(button) {
      button.addEventListener('click', function() {
        toggleFAQ(this);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
